document.addEventListener('DOMContentLoaded', () => {
  function initBlogResults() {
    const loadMore = document.getElementById('blog-load-more');
    if (!loadMore) return;
    loadMore.addEventListener('click', (e) => {
      loadMore.classList.add('is-loading');
      fetch(loadMore.href).then(async (response) => {
        const div = document.createElement('div');
        div.innerHTML = await response.text();
        const articles = Array.from(
          div.querySelector('#blog-articles').children
        );
        document.getElementById('blog-articles').append(...articles);
        articles[0].tabIndex = -1;
        articles[0].focus();

        const newLoadMore = div.querySelector('#blog-load-more');
        if (newLoadMore) {
          loadMore.replaceWith(newLoadMore);
          initBlogResults();
        } else {
          loadMore.remove();
        }
      });
      e.preventDefault();
    });
  }

  initBlogResults();
});
